import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from "react-router-dom";
import Dropdown from './Dropdown';


const Form = styled.form`
display: flex;
width: auto;
align-items: center;
max-width: 445px;
min-width:auto;
background-color: #FFFFFF;
box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
border-radius: 8px;
margin: 20vh 32px 32px 32px;
padding: 16px;
flex-wrap: wrap;
gap: 16px;
justify-content: flex-start;
align-content: center;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
  display:flex;
  flex-direction: column;
  gap:8px;
//   border:solid 1px red;
min-height:85px;
`;

const Label = styled.label`
font-family: 'Montserrat', sans-serif;
font-weight: 800;
font-size: 14px;
color: #07082c;
`;

const Input = styled.input`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
`;

const Select = styled.select`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width:-webkit-fill-available;
  min-width: 215px;
`;

const ErrorMessage = styled.div`
  color: red;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
font-weight: 800;
font-size: 11px;
// color: #07082c;
`;

const AgregarContacto = ({
    openAddContact,
    setOpenAddContact
}) => {


    const navigate = useNavigate()
    const listAsesores =
        ['Enzo',
            'Enzo2',
            'Enzo3',
            'Otros',
            'asdasda'
        ]
    const [user, setUser] = useState(null);
    const [formData, setFormData] = useState({
        nombre: '',
        apellido: '',
        telefono: '',
        email: '',
        ramo: '',
        asesorAsignado: '',
    });
    const [errors, setErrors] = useState({
        nombre: '',
        apellido: '',
        telefono: '',
        email: '',
    });

    const volverAtrazBtn = () => {
        navigate('/contacts');
    }

    useEffect(() => {
        // Validaciones
        const newErrors = {};
        for (const key in formData) {
            if (!formData[key]) {
                newErrors[key] = 'Campo obligatorio';
            } else {
                newErrors[key] = '';
            }
        }
        setErrors(newErrors);
    }, [formData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let formIsValid = true;

        // Verificar si hay algún mensaje de error
        for (const key in errors) {
            if (errors[key]) {
                formIsValid = false;
                break;
            }
        }

        if (formIsValid) {
            // Envía el formulario
            console.log('Formulario válido, enviar datos:', formData);
        } else {
            console.log('El formulario no es válido. Por favor, corrija los errores.');
        }
    };

    return (
        <>
            {
                openAddContact !== true ?
                    <ContainerBox >
                        <Form onSubmit={handleSubmit}>
                            <FormGroup>
                                <Label htmlFor="nombre">Nombre *</Label>
                                <Input
                                    type="text"
                                    id="nombre"
                                    name="nombre"
                                    value={formData.nombre}
                                    onChange={handleChange}
                                    placeholder='Ingrese nombre'
                                />
                                {errors.nombre && <ErrorMessage>{errors.nombre}</ErrorMessage>}
                            </FormGroup>

                            <FormGroup>
                                <Label htmlFor="apellido">Apellido *</Label>
                                <Input
                                    type="text"
                                    id="apellido"
                                    name="apellido"
                                    value={formData.apellido}
                                    placeholder='Ingrese apellido'
                                    onChange={handleChange}
                                />
                                {errors.apellido && <ErrorMessage>{errors.apellido}</ErrorMessage>}
                            </FormGroup>

                            <FormGroup>
                                <Label htmlFor="telefono">Teléfono *</Label>
                                <Input
                                    type="text"
                                    id="telefono"
                                    name="telefono"
                                    value={formData.telefono}
                                    placeholder='Ej: 2213554599'
                                    onChange={handleChange}
                                />
                                {errors.telefono && <ErrorMessage>{errors.telefono}</ErrorMessage>}
                            </FormGroup>

                            <FormGroup>
                                <Label htmlFor="email">Email *</Label>
                                <Input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    placeholder='Ingrese email'
                                    onChange={handleChange}
                                />
                                {errors.email && <ErrorMessage>{errors.email}</ErrorMessage>}
                            </FormGroup>

                            <FormGroup>
                                <Label htmlFor="ramo">Ramo *</Label>
                                <Dropdown
                                    options={['Auto', 'Moto', 'Casa', 'Otros']}
                                    selectedOption={formData.ramo}
                                    setSelectedOption={(option) => setFormData({ ...formData, ramo: option })}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label htmlFor="asesorAsignado">Asignar Asesor *</Label>
                                <Dropdown
                                    options={listAsesores}
                                    selectedOption={formData.asesorAsignado}
                                    setSelectedOption={(option) => setFormData({ ...formData, asesorAsignado: option })}
                                />
                            </FormGroup>
                            <ContainerPaginationButtons>

                                <Boton1
                                    onClick={volverAtrazBtn}
                                >
                                    Volver
                                </Boton1>

                                <Boton1
                                    type="submit"
                                >
                                    Crear Contacto
                                </Boton1>

                            </ContainerPaginationButtons>

                        </Form>
                    </ContainerBox>
                    :
                    <ModalWrapper>
                    <Form
                    style={{
                        margin:'0px'
                    }}
                    onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label htmlFor="nombre">Nombre *</Label>
                            <Input
                                type="text"
                                id="nombre"
                                name="nombre"
                                value={formData.nombre}
                                onChange={handleChange}
                                placeholder='Ingrese nombre'
                            />
                            {errors.nombre && <ErrorMessage>{errors.nombre}</ErrorMessage>}
                        </FormGroup>

                        <FormGroup>
                            <Label htmlFor="apellido">Apellido *</Label>
                            <Input
                                type="text"
                                id="apellido"
                                name="apellido"
                                value={formData.apellido}
                                placeholder='Ingrese apellido'
                                onChange={handleChange}
                            />
                            {errors.apellido && <ErrorMessage>{errors.apellido}</ErrorMessage>}
                        </FormGroup>

                        <FormGroup>
                            <Label htmlFor="telefono">Teléfono *</Label>
                            <Input
                                type="text"
                                id="telefono"
                                name="telefono"
                                value={formData.telefono}
                                placeholder='Ej: 2213554599'
                                onChange={handleChange}
                            />
                            {errors.telefono && <ErrorMessage>{errors.telefono}</ErrorMessage>}
                        </FormGroup>

                        <FormGroup>
                            <Label htmlFor="email">Email *</Label>
                            <Input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                placeholder='Ingrese email'
                                onChange={handleChange}
                            />
                            {errors.email && <ErrorMessage>{errors.email}</ErrorMessage>}
                        </FormGroup>

                        <FormGroup>
                            <Label htmlFor="ramo">Ramo *</Label>
                            <Dropdown
                                options={['Auto', 'Moto', 'Casa', 'Otros']}
                                selectedOption={formData.ramo}
                                setSelectedOption={(option) => setFormData({ ...formData, ramo: option })}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label htmlFor="asesorAsignado">Asignar Asesor *</Label>
                            <Dropdown
                                options={listAsesores}
                                selectedOption={formData.asesorAsignado}
                                setSelectedOption={(option) => setFormData({ ...formData, asesorAsignado: option })}
                            />
                        </FormGroup>
                        <ContainerPaginationButtons>

                            <Boton1
                                onClick={() => setOpenAddContact(false)}
                            >
                                Volver
                            </Boton1>

                            <Boton1
                                type="submit"
                            >
                                Crear Contacto
                            </Boton1>

                        </ContainerPaginationButtons>

                    </Form>
                    </ModalWrapper>
            }
        </>



    );
};

export default AgregarContacto;

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;
const ContainerPaginationButtons = styled.div`
width: 100%;
display: flex;
flex-direction: row;
gap: 8px;
align-items: center;
padding: 0.5em 0.5em 0.5em;
align-self: center;
justify-content: space-between;
`;
const Boton1 = styled.button`
  background-color: #f8f9fa;
  border: 1px solid #f8f9fa;
  border-radius: 4px;
  border-color: #dadce0;
  box-shadow: rgba(0, 0, 0, .1) 0 1px 1px;
  color: #202124;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #07082c;
  height: 36px;
  line-height: 27px;
  min-width: 54px;
  padding: 0 16px;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: pre;
  width: auto;
  min-width:auto;
  
  &:focus {
    border-color: #380418;
    outline: none;
  }
  &:hover {
    box-shadow: #38041852 0px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;

  }
`;

const ContainerContacts = styled.div`
background-color:#FFFFFF !important;
  width: -webkit-fill-available;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  height: 100vh;
`;

const ContainerBox = styled.div`
width: -webkit-fill-available;
height: auto;
min-height: 95vh;
max-height: 95vh;
overflow-y: hidden;
max-width: calc(100vw - 84px);
gap: 16px;

display: flex;
flex-direction: row;
align-items: flex-start;
margin: 1% 16px 0px 90px;
// padding: 0% 2% 0% 2%;
background-color:#FFFFFF;
border-radius:8px;
box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;
`;